import AddressSearch, { EVENT_EDIT_ADDRESS_MANUALLY, EVENT_EDIT_ADDRESS_SEARCH } from '../../components/AddressSearch';
import SelectorEngine from '../../utils/dom/selector-engine';
import Request, { ApiMode } from '../../utils/request';
import EventHandler from '../../utils/dom/event-handler';
import BaseComponent from '../BaseComponent';
import Select from '../../components/Select';
import intlTelInput from 'intl-tel-input';
import Manipulator from '../../utils/dom/manipulator';
import { startLoadingAnimation, stopLoadingAnimation } from '../../utils/dom/loading';
import { scrollToNode } from '../../utils/misc';

const NAME = 'AddPlayer';

const IS_LOCAL = false;

const SELECTOR_ADD_PLAYER_MODAL_EXIT = '.js-exit-add-player';
const SLECTOR_ADD_PLAYER_MODAL_BACK = '.js-add-player-back';

const SELECTOR_ADD_PLAYER_STEP1_BUTTON = '.lta-add-player__content-container-step-1-button';
const SELECTOR_ADD_PLAYER_STEP2_BUTTON = '.lta-add-player__content-container-step-2-button';
const SELECTOR_ADD_PLAYER_STEP3_BUTTON = '.lta-add-player__content-container-step-3-button';
const SELECTOR_ADD_PLAYER_ADDRESS_CONFIRMATION = '.lta-add-player__content-container-address-confirmation';
const SELECTOR_ADD_PLAYER_SAME_ADDRESS = '.lta-add-player__same-address-container';

const SELECTOR_ADD_PLAYER_FIRST_NAME = '.lta-add-player__first-name';
const SELECTOR_ADD_PLAYER_LAST_NAME = '.lta-add-player__last-name';
const SELECTOR_ADD_PLAYER_BIRTH_DATE = '.lta-add-player__birth-date';
const SELECTOR_ADD_PLAYER_GENDER = '.lta-add-player__gender';
const SELECTOR_INPUT_ERROR_LABEL = '.lta-text-input--error';
const SELECTOR_ADDRESS_FORM = '.js-add-player-address';
const SELECTOR_ADDRESS_SEARCH = '.lta-add-player__address';
const SELECTOR_RELATION_SELECT = '.lta-add-player__relationship .js-lta-select';
const SELECTOR_EMERGENCY_CONTACT = '.lta-add-player__emergency-contact-number';
const SELECTOR_SAVE_CHANGE_BUTTON = '.js-save-player-details';

const SELECTOR_SEARCH_ADDRESS_RESULT = '.lta-address-search--result';
const SELECTOR_SEARCH_ADDRESS_FIND = '.lta-address-search--find';
const SELECTOR_SEARCH_ADDRESS_FIND_SUGGEST = '.lta-address-search--find-suggest';
const SELECTOR_SEARCH_ADDRESS_FIND_MANUAL = '.lta-address-search--find-manual';

const SELECTOR_SUGGEST_BUTTON = '.js-auto-submit';
const SELECTOR_MANUAL_BUTTON = '.js-manual-submit';

const SELECTOR_ADD_PLAYER_ERROR = '.add-player-error';
const SELECTOR_ADD_UPDATE_PLAYER_ERROR = '.add-update-player-error';
const SELECTOR_ADD_PLAYER_EXIST_ERROR_BTN = '.add-update-player-error-btn';

const SELECTOR_STEPS = '.steps-container';

const SELECTOR_INPUT = 'input';
const SELECTOR_RADIO = 'radio';

const CLICK_EVENT = 'click';
const CHANGE_EVENT = 'change';
const BLUR_EVENT = 'blur';

const IS_INVALID_CLASS = 'is-invalid';
const IS_FOCUSED_CLASS = 'is-focused';
const HAS_ICON_CLASS = 'has-icon';
const HIDE_CLASS = 'u-hidden';

const INPUT_DATA_VALUE = 'add-Player';
const INPUT_TYPE_TEXT = 'text';
const INPUT_TYPE_NUMBER = 'number';

const TOTAL_STEPS = 3;
const REGEX = /[0-9!@#$%^&*(),.?":{}|<>]/; // prevent special characters excluding -

class AddPlayer extends BaseComponent {
	constructor(element) {
		super(element);
		if (this._element) {
			this.currentStep = 1;
			this._exitCallbacks = [];
			this._submitCallbacks = [];
			this.isAddPlayer = true;
			this.step1Completed = false;
			this.step2Completed = false;
			this.step3Completed = false;
			this.init();
		}
	}
	static get NAME() {
		return NAME;
	}
	get playerData() {
		return this._playerData;
	}
	set playerData(data) {
		this._playerData = data;
		if (!this.isAddPlayer) {
			this.setFormValues(data, this.isAddPlayer);
		}
	}
	init() {
		this.addPlayerModalExitButton = SelectorEngine.findOne(SELECTOR_ADD_PLAYER_MODAL_EXIT, this._element);
		this.addPlayerModalBackButton = SelectorEngine.findOne(SLECTOR_ADD_PLAYER_MODAL_BACK, this._element);
		this.addPlayerAddressConfirmation = SelectorEngine.findOne(SELECTOR_ADD_PLAYER_ADDRESS_CONFIRMATION, this._element);
		this.addPlayerSameAddress = SelectorEngine.findOne(SELECTOR_ADD_PLAYER_SAME_ADDRESS, this._element);
		this.addPlayerSteps = SelectorEngine.findOne(SELECTOR_STEPS, this._element);

		this.addPlayerStep1Button = SelectorEngine.findOne(SELECTOR_ADD_PLAYER_STEP1_BUTTON, this._element);
		this.addPlayerStep2Button = SelectorEngine.findOne(SELECTOR_ADD_PLAYER_STEP2_BUTTON, this._element);
		this.addPlayerStep3Button = SelectorEngine.findOne(SELECTOR_ADD_PLAYER_STEP3_BUTTON, this._element);
		this.saveAllChangesButton = SelectorEngine.findOne(SELECTOR_SAVE_CHANGE_BUTTON, this._element);

		this.firstNameSelector = SelectorEngine.findOne(SELECTOR_ADD_PLAYER_FIRST_NAME, this._element);
		this.lastNameSelector = SelectorEngine.findOne(SELECTOR_ADD_PLAYER_LAST_NAME, this._element);
		this.birthDateSelector = SelectorEngine.findOne(SELECTOR_ADD_PLAYER_BIRTH_DATE, this._element);
		this.genderSelector = SelectorEngine.findOne(SELECTOR_ADD_PLAYER_GENDER, this._element);
		const relationSelectElement = SelectorEngine.findOne(SELECTOR_RELATION_SELECT, this._element);
		if (relationSelectElement) {
			this.relationSelect = Select.getInstance(relationSelectElement) || new Select(relationSelectElement);
		}
		this.emergencyContact = SelectorEngine.findOne(SELECTOR_EMERGENCY_CONTACT, this._element);
		this.emergencyContactValue = SelectorEngine.findOne(SELECTOR_INPUT, this.emergencyContact);
		this.addPlayerError = SelectorEngine.findOne(SELECTOR_ADD_PLAYER_ERROR, this._element);
		this.addUpdatePlayerError = SelectorEngine.findOne(SELECTOR_ADD_UPDATE_PLAYER_ERROR, this._element);
		this.addUpdatePlayerErrorBtn = SelectorEngine.findOne(SELECTOR_ADD_PLAYER_EXIST_ERROR_BTN, this._element);

		this.firstNameValue = SelectorEngine.findOne(SELECTOR_INPUT, this.firstNameSelector);
		this.lastNameValue = SelectorEngine.findOne(SELECTOR_INPUT, this.lastNameSelector);
		this.genderValue = SelectorEngine.find('input[name="gender"]', this.genderSelector);
		this.birthDayValue = SelectorEngine.findOne('input[id="TextInputDay"]', this.birthDateSelector);
		this.birthMonthValue = SelectorEngine.findOne('input[id="TextInputMonth"]', this.birthDateSelector);
		this.birthYearValue = SelectorEngine.findOne('input[id="TextInputYear"]', this.birthDateSelector);
		if (this.addPlayerSameAddress) {
			this.sameAddressValue = SelectorEngine.find('input[name="same-address"]', this.addPlayerSameAddress);
		}
		this.firstNameError = SelectorEngine.findOne(SELECTOR_INPUT_ERROR_LABEL, this.firstNameSelector);
		this.lastNameError = SelectorEngine.findOne(SELECTOR_INPUT_ERROR_LABEL, this.lastNameSelector);
		this.genderError = SelectorEngine.findOne(SELECTOR_INPUT_ERROR_LABEL, this.genderSelector);
		this.birthError = SelectorEngine.findOne(SELECTOR_INPUT_ERROR_LABEL, this.birthDateSelector);
		this.contactNumberError = SelectorEngine.findOne(SELECTOR_INPUT_ERROR_LABEL, this.emergencyContact);

		this.countryCodeInput = intlTelInput(this.emergencyContactValue, {
			preferredCountries: ['gb'],
			separateDialCode: true,
			formatOnDisplay: true
		});

		this.formElementsList = {
			firstName: {
				element: this.firstNameSelector,
				formElement: this.firstNameValue,
				errorElement: this.firstNameError,
				inputType: SELECTOR_INPUT,
				errorMessage: 'Please enter a first name',
				hasIcon: true
			},
			lastName: {
				element: this.lastNameSelector,
				formElement: this.lastNameValue,
				errorElement: this.lastNameError,
				inputType: SELECTOR_INPUT,
				errorMessage: 'Please enter a last name',
				hasIcon: true
			},
			birthDate: {
				TextInputDay: {
					element: this.birthDateSelector,
					formElement: this.birthDayValue,
					errorElement: this.birthError,
					inputType: SELECTOR_INPUT,
					errorMessage: 'Please enter a date of birth',
					hasIcon: false
				},
				TextInputMonth: {
					element: this.birthDateSelector,
					formElement: this.birthMonthValue,
					errorElement: this.birthError,
					inputType: SELECTOR_INPUT,
					errorMessage: 'Please enter a date of birth',
					hasIcon: false
				},
				TextInputYear: {
					element: this.birthDateSelector,
					formElement: this.birthYearValue,
					errorElement: this.birthError,
					inputType: SELECTOR_INPUT,
					errorMessage: 'Please enter a date of birth',
					hasIcon: false
				}
			},
			gender: {
				element: this.genderSelector,
				formElement: this.genderValue,
				errorElement: this.genderError,
				inputType: SELECTOR_RADIO,
				errorMessage: 'Please choose a gender',
				hasIcon: false
			},
			emergencyContactNumber: {
				element: this.emergencyContact,
				formElement: this.emergencyContactValue,
				errorElement: this.contactNumberError,
				inputType: SELECTOR_INPUT,
				errorMessage: 'Please enter a emergency contact number',
				hasIcon: true
			}
		};

		const addPlayerFormInputs = SelectorEngine.find('input', this._element);
		for (const input of addPlayerFormInputs) {
			const inputDataValue = Manipulator.getDataAttribute(input, 'callFrom');
			if(inputDataValue === INPUT_DATA_VALUE && (input.type === INPUT_TYPE_TEXT || input.type === INPUT_TYPE_NUMBER)) {
				EventHandler.on(input, BLUR_EVENT, () => {
					this.validInputValue(this.formElementsList[input.id]);
				});
			}
		}

		const dateFormInputs = SelectorEngine.find('input[type="number"]', this.birthDateSelector);
		for (const input of dateFormInputs) {
			EventHandler.on(input, BLUR_EVENT, () => {
				this.validInputValue(this.formElementsList.birthDate[input.id]);
			});
		}

		if (this.saveAllChangesButton) {
			EventHandler.on(this.saveAllChangesButton, CLICK_EVENT, (event) => {
				this.saveAllChangesButtonAction(event);
			});
		}

		EventHandler.on(this.addPlayerStep1Button, CLICK_EVENT, () => {
			this.addPlayerStep1ButtonAction(true);
		});

		EventHandler.on(this.addPlayerStep2Button, CLICK_EVENT, () => {
			this.addPlayerStep2ButtonAction(true);
		});

		EventHandler.on(this.addPlayerStep3Button, CLICK_EVENT, () => {
			this.addPlayerStep3ButtonAction(true);
		});

		EventHandler.on(this.addPlayerModalExitButton, CLICK_EVENT, () => {
			this.executeExitClickHandler();
			this.playerData = {};
			this.setFormValues(this.playerData, this.isAddPlayer);
		});

		EventHandler.on(this.addPlayerModalBackButton, CLICK_EVENT, () => {
			if (this.currentStep > 1) {
				this.currentStep -= 1;
				this.showCurrentSteps();
			}
		});

		EventHandler.on(this.addUpdatePlayerErrorBtn, CLICK_EVENT, () => {
			this.addUpdatePlayerError.classList.add(HIDE_CLASS);
		});

		this.addressSearchElement = SelectorEngine.findOne(SELECTOR_ADDRESS_SEARCH, this._element);
		this.addressForm = SelectorEngine.findOne(SELECTOR_ADDRESS_FORM, this.addressSearchElement);
		this.addressSearchObject = AddressSearch.getInstance(this.addressSearchElement);

		this.locationsInputs = SelectorEngine.find('input', this.addressSearchElement);

		this.addressResult = SelectorEngine.findOne(SELECTOR_SEARCH_ADDRESS_RESULT, this.addressSearchElement);
		this.addressResultCardContent = SelectorEngine.findOne('.lta-location-card--content', this.addressResult);

		this.addressSearchFind = SelectorEngine.findOne(SELECTOR_SEARCH_ADDRESS_FIND, this.addressSearchElement);
		if (this.addressSearchFind) {
			this.addressSearchFindSuggest = SelectorEngine.findOne(
				SELECTOR_SEARCH_ADDRESS_FIND_SUGGEST,
				this.addressSearchFind
			);
			this.addressSearchFindManual = SelectorEngine.findOne(
				SELECTOR_SEARCH_ADDRESS_FIND_MANUAL,
				this.addressSearchFind
			);
		}
		if (this.isAddPlayer) {
			this.viewAddressConfirmationCheckBox();
		}
		EventHandler.on(this.addressSearchElement, EVENT_EDIT_ADDRESS_MANUALLY, () => {
			this.addPlayerAddressConfirmation?.classList.add(HIDE_CLASS);
		});

		EventHandler.on(this.addressSearchElement, EVENT_EDIT_ADDRESS_SEARCH, () => {
			this.addPlayerAddressConfirmation?.classList.add(HIDE_CLASS);
		});
		EventHandler.on(this.addressForm, CHANGE_EVENT, (event) => {
			const address = event?.detail?.values;
			if (address) {
				this.addressValue = address;
				this.addPlayerAddressConfirmation?.classList.remove(HIDE_CLASS);
				this.addPlayerSameAddress?.classList.add(HIDE_CLASS);
			}
		});

		this.showCurrentSteps();
	}
	viewAddressConfirmationCheckBox() {
		if (!this.addressResult.classList.contains(HIDE_CLASS)) {
			this.addPlayerAddressConfirmation?.classList.remove(HIDE_CLASS);
			this.addPlayerSameAddress?.classList.remove(HIDE_CLASS);
		} else {
			this.addPlayerAddressConfirmation?.classList.add(HIDE_CLASS);
		}
	}
	executeExitClickHandler() {
		for (const callback of this._exitCallbacks) {
			callback();
		}
	}
	onExitClick(callback) {
		this._exitCallbacks.push(callback);
	}
	executeSubmitClickHandler(dataObject) {
		this.addPlayerDetails(dataObject);
	}
	onSubmitClick(callback) {
		this._submitCallbacks.push(callback);
	}
	async addPlayerDetails(playerObject) {
		startLoadingAnimation(true);
		const dataObject = {
			firstName: playerObject.firstName,
			lastName: playerObject.lastName,
			birthDate: playerObject.birthDate,
			gender: playerObject.gender,
			address: {
				type: 'PostalAddress',
				streetAddress: playerObject.address?.street,
				addressLocality: playerObject.address?.city,
				addressRegion: playerObject.address?.state,
				postalCode: playerObject.address?.postCode,
				addressCountry: 'GB'
			},
			contactNo: `${playerObject.emergencyContactDetails.dialCode}${playerObject.emergencyContactDetails.emergencyNumber}`,
			relationshipWithContact: playerObject.relationShip
		};
		try {
			const url = `/api/player/add-player`;
			const responseData = await Request.post(url, dataObject, {
				local: IS_LOCAL,
				req: {
					apiMode: ApiMode.LtaError
			 }
			});

			const { response, error } = responseData;
			if (!!error?.hasError) {
				if(error.errorCode == '01' ) {
					const errorElement = SelectorEngine.findOne('.lta-snackbar__label', this.addUpdatePlayerError);
					errorElement.innerHTML = error.errorMessage;
					this.addUpdatePlayerError.classList.remove(HIDE_CLASS);
					scrollToNode(this.addUpdatePlayerError);
					return;
				}
				throw error;
			}
			if (response) {
				this.playerData = {};
				this.setFormValues(this.playerData, this.isAddPlayer);
				this.addPlayerError.classList.add(HIDE_CLASS);
				for (const callback of this._submitCallbacks) {
					callback(response);
				}
			}
		} catch {
			this.addPlayerError.classList.remove(HIDE_CLASS);
			scrollToNode(this.addPlayerError);
		} finally {
			stopLoadingAnimation();
		}
	}
	saveAllChangesButtonAction(event) {
		this.addPlayerStep1ButtonAction(false);
		this.addPlayerStep2ButtonAction(false);
		this.addPlayerStep3ButtonAction(false);

		this.addressResult = SelectorEngine.findOne(SELECTOR_SEARCH_ADDRESS_RESULT, this._element);
		let isAddressAvailable = true;
		if (this.addressResult.classList.contains(HIDE_CLASS)) {
			isAddressAvailable = false;
			if (this.addressSearchFind) {
				if (!this.addressSearchFindSuggest.classList.contains(HIDE_CLASS)) {
					const suggestFormButton = SelectorEngine.findOne(SELECTOR_SUGGEST_BUTTON, this.addressSearchFindSuggest);
					suggestFormButton.click();
				}

				if (!this.addressSearchFindManual.classList.contains(HIDE_CLASS)) {
					const manualFormButton = SelectorEngine.findOne(SELECTOR_MANUAL_BUTTON, this.addressSearchFindManual);
					manualFormButton.click();
				}
			}
		}

		if (this.step1Completed && this.step2Completed && this.step3Completed && isAddressAvailable) {
			this.updatePlayerDetails(this.playerData, event);
		}
	}
	async updatePlayerDetails(playerObject, event) {
		startLoadingAnimation(true);
		const redirectUrl = event.currentTarget.dataset.target;
		const dataObject = {
			firstName: playerObject.firstName,
			lastName: playerObject.lastName,
			birthDate: playerObject.birthDate,
			gender: playerObject.gender,
			address: {
				type: 'PostalAddress',
				streetAddress: playerObject.address?.street,
				addressLocality: playerObject.address?.city,
				addressRegion: playerObject.address?.state,
				postalCode: playerObject.address?.postCode,
				addressCountry: 'GB'
			},
			contactNo: `${playerObject.emergencyContactDetails.dialCode}${playerObject.emergencyContactDetails.emergencyNumber}`,
			relationshipWithContact: playerObject.relationShip,
			playerId: playerObject.id
		};
		try {
			const url = `/api/player/update-player`;
			const responseData = await Request.put(url, dataObject, {
				local: IS_LOCAL,
				req: {
					apiMode: ApiMode.LtaError
				}
			});

			const { response, error } = responseData;
			if (!!error?.hasError) {
				const errorElement = SelectorEngine.findOne('.lta-snackbar__label', this.addUpdatePlayerError);
				errorElement.innerHTML = error.errorMessage;
				this.addUpdatePlayerError.classList.remove(HIDE_CLASS);	
				scrollToNode(this.addUpdatePlayerError);
			}
			if (response) {
				this.goToUrl(event, redirectUrl);
			}

			
		} catch {
			this.addPlayerError.classList.remove(HIDE_CLASS);
			scrollToNode(this.addPlayerError);
		} finally {
			stopLoadingAnimation();
		}
	}
	goToUrl(event, redirectUrl) {
		const rootUrl = window.location.origin;
		const url = redirectUrl || event.currentTarget.dataset.target;
		window.location.href = `${rootUrl}${url}`;
	}
	addPlayerStep3ButtonAction(isStep) {
		const emergencyContactData = this.validInputValue(this.formElementsList.emergencyContactNumber);
		this.relationSelectValue = this.relationSelect._selectNativeElement.value;
		if (emergencyContactData) {
			this.isAddPlayer = true;
			this.playerData = {
				...this.playerData,
				emergencyContactDetails: {
					...this.countryCodeInput.getSelectedCountryData(),
					emergencyNumber: emergencyContactData
				},
				relationShip: this.relationSelectValue
			};
			this.step3Completed = true;
			if (isStep) {
				this.executeSubmitClickHandler(this.playerData);
			}
		}
	}
	setFormValues(playerObject, isAddPlayer) {
		this.firstNameValue.value = playerObject.firstName || '';
		this.lastNameValue.value = playerObject.lastName || '';
		for (const radioButton of this.genderValue) {
			if (playerObject.gender === radioButton.value) {
				radioButton.checked = 'checked';
			} else {
				radioButton.checked = false;
			}
		}

		const birthDate = new Date(playerObject.dateOfBirth);
		this.birthDayValue.value = String(birthDate.getDate()).padStart(2, '0') || '';
		this.birthMonthValue.value = String(birthDate.getMonth() + 1).padStart(2, '0') || '';
		this.birthYearValue.value = birthDate.getFullYear() || '';

		this.addressValue = playerObject.address
			? {
				street: playerObject.address?.streetAddress,
				city: playerObject.address?.addressLocality,
				state: playerObject.address?.addressRegion,
				postCode: playerObject.address?.postalCode
			}
			: '';

		if (playerObject.contactNo) {
			this.countryCodeInput.setNumber(playerObject.contactNo);
		} else {
			this.emergencyContactValue.value = '';
			this.countryCodeInput.setCountry('gb');
		}

		if (this.addressValue && !isAddPlayer) {
			setTimeout(() => {
				this.addressSearchObject.populateManualForm(this.addressValue);
			}, 100);
		}

		if (playerObject.relationshipWithContact) {
			let selectedRelationShipOption;
			for (const option of this.relationSelect._selectNativeElement.options) {
				if (option.value === playerObject.relationshipWithContact) {
					selectedRelationShipOption = option;
				}
			}
			this.relationSelect.selectedOptions = [selectedRelationShipOption];
		} else {
			this.relationSelect.reset();
		}

		if (isAddPlayer) {
			this.currentStep = 1;
			this.showCurrentSteps();

			this.firstNameError.innerHTML = '';
			this.lastNameError.innerHTML = '';
			this.genderError.innerHTML = '';
			this.birthError.innerHTML = '';
			this.sameAddressValue[0].checked = 'checked';

			this.addressSearchFindSuggest?.classList.remove(HIDE_CLASS);
			this.addressResult?.classList.add(HIDE_CLASS);
			this.addressSearchFindManual?.classList.add(HIDE_CLASS);
			this.addressSearchFindSuggest?.classList.add(HIDE_CLASS);
			this.addressResultCardContent.innerHTML = '';
			this.addressSearchObject.resetView();
			for (const inputBox of this.locationsInputs) {
				inputBox.value = '';
			}
			this.removeAllErrors();
			this.addressResultCheck();
			this.addPlayerError.classList.add(HIDE_CLASS);
			this.relationSelect.reset();
			this._element.scrollTop = 0;
		}
	}
	async addressResultCheck() {
		try {
			await this.addressSearchObject.getUserAddress();
			this.addressResult = SelectorEngine.findOne(SELECTOR_SEARCH_ADDRESS_RESULT, this.addressSearchElement);
			this.viewAddressConfirmationCheckBox();
		} catch (error) {
			console.log(error);
		}
	}
	removeAllErrors() {
		this.addressInputs = SelectorEngine.find('.lta-text-input__wrapper', this.addressSearchElement); 
		for (const addressInput of this.addressInputs) {
			addressInput?.classList.remove(IS_INVALID_CLASS);
			addressInput?.classList.remove(IS_FOCUSED_CLASS);
			addressInput?.classList.remove(HAS_ICON_CLASS);
		}
	}
	addPlayerStep2ButtonAction(isStep) {
		if (isStep) {
			const isSameAddress = SelectorEngine.findOne('input[name="same-address"]:checked', this.addPlayerSameAddress);
			if(isSameAddress.value === 'no') {
				if(this.addPlayerSameAddress.classList.contains(HIDE_CLASS)) {
					this.redirecToThirdStep();
				} else {
					this.addPlayerAddressConfirmation?.classList.add(HIDE_CLASS);
					this.addressSearchObject.handleSearchAgain();
				}
			} else {
				this.redirecToThirdStep();
			}
		} else {
			this.isAddPlayer = true;
			if (this.addressValue) {
				this.playerData = {
					...this.playerData,
					address: this.addressValue
				};
			}
			this.step2Completed = true;
		}
	}
	redirecToThirdStep() {
		this.isAddPlayer = true;
		this.playerData = {
			...this.playerData,
			address: this.addressValue
		};
		this.currentStep = 3;
		this.showCurrentSteps();
	}
	addPlayerStep1ButtonAction(isStep) {
		const firstNameData = this.validInputValue(this.formElementsList.firstName);
		const lastNameData = this.validInputValue(this.formElementsList.lastName);
		const birthDayData = this.validInputValue(this.formElementsList.birthDate.TextInputDay);
		const birthMonthData = this.validInputValue(this.formElementsList.birthDate.TextInputMonth);
		const birthYearData = this.validInputValue(this.formElementsList.birthDate.TextInputYear);
		const genderData = this.validInputValue(this.formElementsList.gender);

		if (firstNameData && lastNameData && birthDayData && birthMonthData && birthYearData && genderData) {
			this.isAddPlayer = true;
			this.playerData = {
				...this.playerData,
				firstName: firstNameData,
				lastName: lastNameData,
				birthDate: `${birthYearData}-${birthMonthData}-${birthDayData}`,
				gender: genderData
			};
			this.step1Completed = true;
			if (isStep) {
				this.currentStep = 2;
				this.viewAddressConfirmationCheckBox();
				this.showCurrentSteps();
			}
		}
	}

	// To check if date is valid
	dateValidate(year, month, day) {
		const parseMonth = parseInt(month - 1);
		const d = new Date(year, parseMonth, day);
		if (d.getFullYear() == year && d.getMonth() == parseMonth && d.getDate() == day) {
			return true;
		}
		return false;
	}

	// To check if the date is in past
	restictFutureDate(day, month, year) {
		const today = new Date();
		const inputDate = new Date(`${year}-${month}-${day}`);
		return inputDate <= today;
	}

	validInputValue(elementObject) {
		let formElementValue;
		if (elementObject.inputType === SELECTOR_INPUT) {
			formElementValue = elementObject.formElement.value;
		} else if (elementObject.inputType === SELECTOR_RADIO) {
			for (const radioButton of elementObject.formElement) {
				if (radioButton.checked) {
					formElementValue = radioButton.value;
				}
			}
		}
		if (!formElementValue) {
			this.addInvalidClasses(elementObject.element, elementObject.hasIcon);
			elementObject.errorElement.innerHTML = elementObject.errorMessage;
			return '';
		} else if (
			elementObject === this.formElementsList.birthDate.TextInputDay ||
			elementObject === this.formElementsList.birthDate.TextInputMonth ||
			elementObject === this.formElementsList.birthDate.TextInputYear
		) {
			// For birth date fields, validate age
			const birthDay = this.formElementsList.birthDate.TextInputDay.formElement.value;
			const birthMonth = this.formElementsList.birthDate.TextInputMonth.formElement.value;
			const birthYear = this.formElementsList.birthDate.TextInputYear.formElement.value;

			// calculating age
			const today = new Date();
			const birthDate = new Date(`${birthYear}-${birthMonth}-${birthDay}`);
			const age = today.getFullYear() - birthDate.getFullYear();

			const isValidDate = this.dateValidate(birthYear, birthMonth, birthDay);
			if (birthDay === '' || birthMonth === '' || birthYear === '') {
				this.addInvalidClasses(elementObject.element, elementObject.hasIcon);
				elementObject.errorElement.innerHTML = 'Please enter a date of birth';
				return '';
			} else if (!isValidDate) {
				this.addInvalidClasses(elementObject.element, elementObject.hasIcon);
				elementObject.errorElement.innerHTML = 'Please enter a valid date';
				return '';
			} else if (age > 18) {
				this.addInvalidClasses(this.formElementsList.birthDate.TextInputDay.element, elementObject.hasIcon);
				this.formElementsList.birthDate.TextInputDay.errorElement.innerHTML = 'Child needs to be below 18 years of age';
				return '';
			} else if (!this.restictFutureDate(birthDay, birthMonth, birthYear)) {
				this.addInvalidClasses(elementObject.element, elementObject.hasIcon);
				elementObject.errorElement.innerHTML = 'Please enter a date in the past';
				return '';
			}
		} else if (elementObject === this.formElementsList.firstName) {
			// Validate first name
			if (REGEX.test(formElementValue)) {
				this.addInvalidClasses(elementObject.element, elementObject.hasIcon);
				elementObject.errorElement.innerHTML = 'Please enter a valid first name';
				return '';
			}
		} else if (elementObject === this.formElementsList.lastName) {
			// Validate last name
			if (REGEX.test(formElementValue)) {
				this.addInvalidClasses(elementObject.element, elementObject.hasIcon);
				elementObject.errorElement.innerHTML = 'Please enter a valid last name';
				return '';
			}
		} 
		this.removeInvalidClasses(elementObject.element);
		elementObject.errorElement.innerHTML = '';
		return formElementValue;
	}
	addInvalidClasses(element, hasIcon) {
		element.classList.add(IS_INVALID_CLASS);
		element.classList.add(IS_FOCUSED_CLASS);
		if (hasIcon) {
			element.classList.add(HAS_ICON_CLASS);
		}
	}
	removeInvalidClasses(element) {
		element.classList.remove(IS_INVALID_CLASS);
		element.classList.remove(IS_FOCUSED_CLASS);
		element.classList.remove(HAS_ICON_CLASS);
	}
	showCurrentSteps() {
		if (this.addPlayerSteps) {
			for (let index = 1; index <= TOTAL_STEPS; index++) {
				const addPlayerStep = SelectorEngine.findOne('.add-player-step-' + index, this._element);
				const addPlayerStepContainer = SelectorEngine.findOne(
					'.lta-add-player__content-container-step-' + index,
					this._element
				);

				if (this.currentStep === 1) {
					this.addPlayerModalBackButton.classList.add(HIDE_CLASS);
				} else {
					this.addPlayerModalBackButton.classList.remove(HIDE_CLASS);
				}

				if (index === this.currentStep) {
					addPlayerStep.classList.remove(HIDE_CLASS);
					addPlayerStepContainer.classList.remove(HIDE_CLASS);
				} else {
					addPlayerStep.classList.add(HIDE_CLASS);
					addPlayerStepContainer.classList.add(HIDE_CLASS);
				}
			}
		}
	}
}
export default AddPlayer;
